import { Component } from '@angular/core';

@Component({
  selector: 'valg-dk-map-legend',
  templateUrl: './map-legend.component.html',
  styleUrls: [ './map-legend.component.scss' ]
})
export class MapLegendComponent {

}
